import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { useHistory, Link } from 'react-router-dom';
import AdminMenuWrapper from '@admin/nav_menu/AdminMenuWrapper';
import { PageWrapper, TitleText, BasicText, BasicButton, ShortInput } from '@components';
import styles from './AdminHome.module.css';
import UserHome from '@users/UserHome';

const AdminHome = () => {
  return (
    <AdminMenuWrapper>
      <UserHome />
    </AdminMenuWrapper>
  );
};

export default AdminHome;
